import { useModal } from './ModalContext'
import Link from '@commons/link/Link.tsx'
import { Link as LinkProps } from '@commons/drupal.types'
import { LinkTextColor } from '@components/secondary-hero/types'
import React from 'react'

type ModalTriggerProps = {
    onClick?: () => void
    isLink?: boolean
} & LinkProps

const ModalTrigger = ({
    onClick,
    isLink = true,
    ...props
}: ModalTriggerProps) => {
    const { open } = useModal()

    if (!props?.label?.trim()) return null

    const handleTrigger = (
        e: React.MouseEvent<HTMLAnchorElement | HTMLSpanElement>
    ) => {
        e.preventDefault()
        open()
        onClick?.()
    }

    if (!isLink) {
        return (
            <span
                onClick={e => {
                    handleTrigger(e)
                }}>
                {props.label}
            </span>
        )
    }

    return (
        <Link
            {...props}
            variant={
                props?.config?.link_text_color === 'gold'
                    ? 'highlight'
                    : (props?.config?.link_text_color as LinkTextColor) ||
                      props.variant
            }
            onClick={e => {
                handleTrigger(e)
            }}
            data-testid="modal-trigger"
        />
    )
}

export default ModalTrigger
